import { useEffect } from "react";
import { toast } from "sonner";
import { tasksApi } from "@/lib/api";

// Global keyboard shortcuts for the Schedule page:
//   Cmd/Ctrl+K → open palette
//   Shift+?    → open help
//   Esc        → close drawers + clear selection
//   Del/Backspace (with selection) → bulk delete
//   Cmd/Ctrl+D → duplicate currently-detailed task
export function useScheduleKeyboard({
  selectionLength,
  detailTaskId,
  detailTaskTitle,
  onBulkDelete,
  setPaletteOpen,
  setHelpOpen,
  setSelection,
  setHistoryOpen,
  setDetailOpen,
  refresh,
}) {
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setPaletteOpen(true);
        return;
      }
      // Shift + ? opens help. Skip when typing into an input/textarea.
      if (e.key === "?" && e.shiftKey &&
          !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName)) {
        e.preventDefault();
        setHelpOpen(true);
        return;
      }
      if (e.key === "Escape") {
        setSelection([]);
        setHistoryOpen(false);
        setDetailOpen(false);
      }
      if ((e.key === "Delete" || e.key === "Backspace") && selectionLength > 0 &&
          !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName)) {
        e.preventDefault();
        onBulkDelete();
      }
      // ⌘D / Ctrl+D — duplicate the currently-detailed task. Browsers
      // hijack this for "bookmark" so we preventDefault.
      if ((e.metaKey || e.ctrlKey) && (e.key === "d" || e.key === "D")) {
        if (["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName)) return;
        if (!detailTaskId) return;
        e.preventDefault();
        tasksApi.duplicate(detailTaskId).then(() => {
          toast.success(`Duplicated "${detailTaskTitle}" — find it in FLOATING`);
          refresh();
        }).catch((err) => {
          toast.error(err.response?.data?.detail || "Duplicate failed");
        });
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionLength, onBulkDelete, detailTaskId]);
}
